import { ProductZoneType } from "../enums";

// 常用路由栈
export const RouteStack = {
  Home: "home",
  PersonalCenter: "personal-center",
  AboutUs: "about-us",
  La: "la",
  Login: "login",
  Brand: "brand",
  LowPrice: "lowprice",
  Winter: "winter",
  Christmas: {
    activity: "christmas",
    detail: "christmas/details",
    rank: "christmas/rank",
  },
  Black5: {
    activity: "black5",
    rank: "black5/rank",
  },
  Product: {
    products: "products",
    product: "product/detail",
  },
  Recommended: {
    highCommission: `recommended/${ProductZoneType.HighCommission}`,
    bestSelling: `recommended/${ProductZoneType.BestSelling}`,
    youMayLike: `recommended/${ProductZoneType.YouMayLike}`,
  },
  FgvCon2025: "fgvcon-2025",
  User: {
    privacyPolicy: "privacy-policy",
    termsOfService: "terms-of-service",
    personalCenter: "personal-center",
  },
  Oauth: {
    callback: "oauth/callback",
    ttspc: "oauth/callback/ttspc",
  },
  CreatorsPicks2025: "creators-picks-2025",
  Spring: {
    activity: "holiday/spring",
    rank: "holiday/spring/rankRule",
  },
  Easter: {
    activity: "holiday/easter",
    rank: "holiday/easter/rank",
  },
  Dallas2025: {
    activity: "creator-picks-2025-dallas",
    signUp: "creator-picks-2025-dallas/sign-up",
    becomeSponsor: "creator-picks-2025-dallas/become-sponsor",
  },
  La2025: {
    activity: "creator-picks-2025-la",
    signUp: "creator-picks-2025-la/sign-up",
    becomeSponsor: "creator-picks-2025-la/become-sponsor",
  },
};
